export default function addTooltip() {
    const tooltips = document.querySelectorAll('.custom-tooltip');
    tooltips.forEach((tooltip) => {
      let tooltipBox;
      tooltip.addEventListener('mouseenter', (event) => {
        const text = event.target.getAttribute('aria-label');
        tooltipBox = document.createElement('div');
        tooltipBox.classList.add('tooltip-box');
        tooltipBox.style.position = 'fixed';
        tooltipBox.style.backgroundColor = 'white';
        tooltipBox.style.border = '1px solid black';
        tooltipBox.style.color = 'black';
        tooltipBox.style.fontSize = '12px';
        tooltipBox.style.padding = '7px';
        tooltipBox.innerText = text;
        document.body.appendChild(tooltipBox);
      });
  
      tooltip.addEventListener('mousemove', (event) => {
        if (tooltipBox) {
          tooltipBox.style.top = `${event.clientY + 15}px`;
          tooltipBox.style.left = `${event.clientX + 10}px`;
        }
      });
  
      tooltip.addEventListener('mouseleave', () => {
        if (tooltipBox) {
          document.body.removeChild(tooltipBox);
          tooltipBox = null;
        }
      });
    });
  } 


// WEBPACK FOOTER //
// ./src/utils/customTooltip.js